import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('discardMarkAsReadOption')(function discardMarkAsReadOption(state) {
    var optionState = state.optionState;
    optionState.behavior = null;
    optionState.delay = null;
}));
//# sourceMappingURL=discardMarkAsReadOption.js.map